module.exports = require("react-i18next");